import { forwardRef } from "react";
import PDFBranding from "../../../../Universal/SAS Branding/PDFBranding.component";
import Title from "../../../../Universal/Title.component";

const DownloadStudentBasicData = forwardRef(
  ({ student, schoolDetails }, ref) => {
    return (
      <div>
        <div className="hidden-print">
          <div
            id="pdf-content"
            ref={ref}
            className="flex-col align-left justify-start w-full g-1"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "1rem",
                borderBottom: "1px solid #000000",
                paddingBottom: "1rem",
                width: "100%",
              }}
            >
              {/* Profile Image */}
              <div style={{ flex: "0 0 auto" }}>
                <img
                  src={student.image || "/default-profile.jpg"}
                  alt="Student Profile"
                  style={{
                    width: "3.5cm",
                    height: "4.5cm",
                    objectFit: "cover",
                  }}
                />
              </div>

              {/* School Info and Student Name */}
              <div style={{ textAlign: "right", flex: "1" }}>
                <Title>{schoolDetails?.schoolName}</Title>
                <p className="t-10 poppins">{schoolDetails?.schoolAddress}</p>
                <p className="t-13 poppins" style={{ marginTop: "0.5rem" }}>
                  <strong>Student Name:</strong> {student?.name}
                </p>
                <p className="t-13 poppins">
                  <strong>ID:</strong> {student.id || "N/A"}
                </p>
              </div>
            </div>
            <table
              border="1"
              cellPadding="8"
              cellSpacing="0"
              style={{ width: "100%", borderCollapse: "collapse" }}
            >
              <tbody>
                <tr>
                  <th className="p-05 poppins t-13" colSpan={2}>
                    Basic Information
                  </th>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Gender</td>
                  <td className="p-05 poppins t-13">{student.gender}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Date of Birth</td>
                  <td className="p-05 poppins t-13">{student.dob}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Father's Name</td>
                  <td className="p-05 poppins t-13">{student.fathersName}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Mother's Name</td>
                  <td className="p-05 poppins t-13">{student.mothersName}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Guardian</td>
                  <td className="p-05 poppins t-13">{student.gurdian}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Guardian Phone No</td>
                  <td className="p-05 poppins t-13">
                    {student.guardianPhoneNo}
                  </td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Aadhaar No</td>
                  <td className="p-05 poppins t-13">{student.aadhaarNo}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Phone No</td>
                  <td className="p-05 poppins t-13">{student.phoneNo}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Email</td>
                  <td className="p-05 poppins t-13">{student.email}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Nationality</td>
                  <td className="p-05 poppins t-13">{student.nationality}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Pincode</td>
                  <td className="p-05 poppins t-13">{student.pincode}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Address</td>
                  <td className="p-05 poppins t-13">{student.address}</td>
                </tr>

                <tr>
                  <th className="p-05 poppins t-13" colSpan={2}>
                    Academic Info
                  </th>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Admission Date</td>
                  <td className="p-05 poppins t-13">
                    {student.academic.admissionData}
                  </td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Class</td>
                  <td className="p-05 poppins t-13">
                    {student.academic.currentClass}
                  </td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Section</td>
                  <td className="p-05 poppins t-13">
                    {student.academic.section}
                  </td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Roll No</td>
                  <td className="p-05 poppins t-13">
                    {student.academic.rollNo}
                  </td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Reporting Teacher</td>
                  <td className="p-05 poppins t-13">
                    {student.academic.reportingTeacher}
                  </td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Monthly Fees</td>
                  <td className="p-05 poppins t-13">
                    {student.academic.monthlyFees}
                  </td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Fees Type</td>
                  <td className="p-05 poppins t-13">
                    {student.academic.feesType}
                  </td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Behavior</td>
                  <td className="p-05 poppins t-13">
                    {student.academic.behavior}
                  </td>
                </tr>

                <tr>
                  <th className="p-05 poppins t-13" colSpan={2}>
                    Subject Strengths
                  </th>
                </tr>
                {student.subjectStrengths.map((sub, idx) => (
                  <tr key={idx}>
                    <td className="p-05 poppins t-13">{sub.name}</td>
                    <td className="p-05 poppins t-13">
                      <div className="flex-row align-center justify-start g-2">
                        {sub.strength} / {sub.totalVal} <br />
                        <span
                          style={{
                            backgroundColor: sub.backgroundColor,
                            color: sub.color,
                            borderRadius: "4px",
                          }}
                        >
                          {sub.color}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}

                <tr>
                  <th className="p-05 poppins t-13" colSpan={2}>
                    Other Info
                  </th>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Subject Weakness</td>
                  <td className="p-05 poppins t-13">
                    {student.subjectWeakness}
                  </td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Extra Activity</td>
                  <td className="p-05 poppins t-13">{student.extraActivity}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Like To Do</td>
                  <td className="p-05 poppins t-13">{student.likeToDo}</td>
                </tr>
                <tr>
                  <td className="p-05 poppins t-13">Behavior</td>
                  <td className="p-05 poppins t-13">{student.behavior}</td>
                </tr>

                <tr>
                  <th className="p-05 poppins t-13" colSpan={2}>
                    Achievements
                  </th>
                </tr>
                {student.achievements.map((ach, idx) => (
                  <tr key={idx}>
                    <td className="p-05 poppins t-13">{ach.title}</td>
                    <td className="p-05 poppins t-13">{ach.position}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <PDFBranding />
          </div>
        </div>
      </div>
    );
  }
);

export default DownloadStudentBasicData;
